import type { BaseBlock } from "@/react/components/shared/BuilderUI/DataModel.types";

export const defaultData: BaseBlock = {
  id: "form-button-block",
  type: "FormButtonBlock",
  props: {
    label: {
      prop: "other",
      type: "string",
      value: "Submit",
    },
  },
};
